import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import { ApiToken } from "../../api/ApiTokens";

// ApiTokenCreated is the one time the token is readable. The server keeps only a hash
// of it, so a token that isn't copied here can only be replaced.
export function ApiTokenCreated(props: {
    value: ApiToken;
    onClose: () => void;
}) {
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        await navigator.clipboard.writeText(props.value.token);
        setCopied(true);
    };

    return (
        <Dialog open fullWidth maxWidth="sm" onClose={props.onClose}>
            <DialogTitle>{props.value.name}</DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Copy this now. It isn't shown again.
                </Alert>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{
                        flex: 1,
                        minWidth: 0,
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "grey.100",
                        fontFamily: "monospace",
                        fontSize: 13,
                        overflowWrap: "anywhere",
                    }}>
                        {props.value.token}
                    </Box>
                    <Tooltip title={copied ? "Copied" : "Copy"}>
                        <IconButton onClick={copy}><ContentCopy fontSize="small" /></IconButton>
                    </Tooltip>
                </Box>

                <Box sx={{ mt: 2, fontSize: 13, color: "text.secondary" }}>
                    Send it on every request as a bearer token:
                    <Box sx={{
                        mt: 0.5,
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "grey.100",
                        fontFamily: "monospace",
                        overflowWrap: "anywhere",
                    }}>
                        Authorization: Bearer {props.value.token}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={props.onClose}>Done</Button>
            </DialogActions>
        </Dialog>
    );
}
